import { render, staticRenderFns } from "./TextCopier.vue?vue&type=template&id=066265da&"
import script from "./TextCopier.vue?vue&type=script&lang=js&"
export * from "./TextCopier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports